// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1Q7Qp","overflowing":"ReadFullNote_overflowing__1wZy2"};